module.exports = __webpack_public_path__ + "static/media/03.92c03c57.jpg";